export default function authHeader() {
  const authUser = localStorage.getItem("authUser")

  if (authUser) {
    return { Authorization: authUser }
  } else {
    return {}
  }
}
